/**
 * Type of cluster based on confidence and formation
 */
export var ClusterType;
(function (ClusterType) {
    ClusterType["DEFINITE_MERGE"] = "DEFINITE_MERGE";
    ClusterType["PROBABLE_MERGE"] = "PROBABLE_MERGE";
    ClusterType["NEEDS_REVIEW"] = "NEEDS_REVIEW";
    ClusterType["SINGLETON"] = "SINGLETON";
})(ClusterType || (ClusterType = {}));
/**
 * Suggested action for the cluster
 */
export var ClusterAction;
(function (ClusterAction) {
    ClusterAction["AUTO_MERGE"] = "AUTO_MERGE";
    ClusterAction["REVIEW_BEFORE_MERGE"] = "REVIEW_BEFORE_MERGE";
    ClusterAction["MANUAL_REVIEW"] = "MANUAL_REVIEW";
    ClusterAction["NO_ACTION"] = "NO_ACTION";
})(ClusterAction || (ClusterAction = {}));
